export const valueToLocaleString= (value) => value ? Number(value).toLocaleString('en-US') : 0;

